import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  "type": "limit",
  "name": "Limit",
  "category": "data",
  "description": "Limit the number of items returned",
  "icon": "MinusCircle",
  "color": "cyan",
  "version": "1.1.0",
  "group": [
    "transform"
  ],
  "defaults": {
    "name": "Limit",
    "color": "#06b6d4"
  },
  "inputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Input",
      "required": true
    }
  ],
  "outputs": [
    {
      "name": "default",
      "type": "main",
      "displayName": "Output"
    }
  ],
  "tags": [
    "limit",
    "take",
    "first",
    "slice"
  ],
  "comingSoon": false
};

export default definition;
